// @flow

import React, { type Node, Component } from 'react';
import classNames from 'classnames';

import {
  Grid,
  injectSheet,
  type InjectSheetProvidedProps,
  type ThemeType
} from '@catalytic/catalytic-ui';

import LoginFooter from './LoginFooter';
import LoginHeader from './LoginHeader';

export const Style = (theme: ThemeType) => ({
  left: {
    height: '100vh',
    justifyContent: 'flex-start',
    [theme.breakpoints.gt.mobile.portrait]: {
      justifyContent: 'space-between'
    }
  },
  content: {
    maxWidth: '100%',
    margin: '0.5rem 0'
  },
  footer: { width: '100%' },
  navBar: { height: '3.5rem' },
  animated: {
    animationDuration: theme.variables.animationDuration,
    animationFillMode: theme.variables.animationFillMode,
    opacity: 0
  },
  enter: {
    animationName: theme.variables.fadeIn,
    opacity: 1
  }
});

type Props = InjectSheetProvidedProps & {
  children: Node,
  descriptionText: string,
  fetched: boolean,
  headlineText: string,
  hasRocket: boolean
};

export class LoginLayout extends Component<Props> {
  static displayName = 'LoginLayout';
  render() {
    const { classes, children, fetched, hasRocket } = this.props;

    return (
      <>
        <Grid container>
          <Grid
            container
            direction="column"
            alignItems="center"
            className={classes.left}
            wrap="nowrap"
          >
            {hasRocket ? (
              <Grid item>
                <div className={classes.navBar} />
              </Grid>
            ) : (
              <Grid item>
                <LoginHeader />
              </Grid>
            )}
            <Grid
              item
              className={classNames(
                classes.animated,
                { [classes.enter]: fetched },
                classes.content
              )}
            >
              {children}
            </Grid>
            {hasRocket ? (
              <Grid item>
                <div className={classes.navBar} />
              </Grid>
            ) : (
              <Grid item>
                <LoginFooter splitScreen />
              </Grid>
            )}
          </Grid>
        </Grid>
      </>
    );
  }
}

export default injectSheet(Style)(LoginLayout);
